import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../../common/util/redux';
import {HomeTabPage} from '../../common/type';
import {ITimeTable, ITimeTableGenre, ITimeTableSortKey} from '../type';

export interface IStateTimeTable {
  [HomeTabPage.TimeTable]: ITimeTable;
  sortKeyByDayTab: ITimeTableSortKey;
  genre: {
    [HomeTabPage.TimeTable]: ITimeTableGenre;
  };
}

const DEFAULT_DAYS_STATE = {
  contents: [],
  multiCellIndexList: [],
};
const DEFAULT_DAYS_TAB_STATE = {
  mon: DEFAULT_DAYS_STATE,
  tue: DEFAULT_DAYS_STATE,
  wed: DEFAULT_DAYS_STATE,
  thu: DEFAULT_DAYS_STATE,
  fri: DEFAULT_DAYS_STATE,
  sat: DEFAULT_DAYS_STATE,
  sun: DEFAULT_DAYS_STATE,
};
const DEFAULT_TIME_TABLE_STATE = {
  newTabContents: [],
  completeTab: {
    contents: [],
  },
  daysTab: DEFAULT_DAYS_TAB_STATE,
};
const DEFAULT_GENRE_STATE = {
  selectedKey: '',
  list: [],
};

const INITIAL_STATE: IStateTimeTable = {
  [HomeTabPage.TimeTable]: DEFAULT_TIME_TABLE_STATE,
  sortKeyByDayTab: 'recommend',
  genre: {
    [HomeTabPage.TimeTable]: DEFAULT_GENRE_STATE,
  },
};

export default createReducer<
  IStateTimeTable,
  ReducerActionHelper<typeof actions>
>(INITIAL_STATE, {
  ...createBasicReducerHandlers({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  [ActionType.SetNewContents]: (state, action) => {
    const {page, contents} = action.payload;
    state[page].newTabContents = contents;
  },
  [ActionType.SetCompletedContents]: (state, action) => {
    const {bigContent, contents, page} = action.payload;
    state[page].completeTab.bigContent = bigContent;
    state[page].completeTab.contents = contents;
  },
  [ActionType.SetCompletedGenres]: (state, action) => {
    const {data} = action.payload;
    state.genre[HomeTabPage.TimeTable].selectedKey = data[0]?.key || '';
    state.genre[HomeTabPage.TimeTable].list = data;
  },
  [ActionType.SetCompletedGenreKey]: (state, action) => {
    const {page, selectedKey} = action.payload;
    state.genre[page].selectedKey = selectedKey;
  },
  [ActionType.SetDayContent]: (state, action) => {
    const {day, item, sortKey} = action.payload;
    const dayItem = state[HomeTabPage.TimeTable].daysTab;
    // 배너가 없을 수 있기 때문에 이전에 있던 데이터도 같이 입력
    dayItem[day] = {
      ...dayItem[day],
      ...item,
    };

    if (sortKey) {
      state.sortKeyByDayTab = sortKey;
    }
  },
  [ActionType.SetWeekdaysContents]: (state, action) => {
    const {page, contentListByDays} = action.payload;
    state[page].daysTab = contentListByDays;
  },
  [ActionType.SetNewContentLike]: (state, action) => {
    const {index, isLike} = action.payload;
    const content = state[HomeTabPage.TimeTable].newTabContents[index];
    if (content) {
      content.isLike = isLike;
    }
  },
  [ActionType.InitializeTimeTable]: (state, action) => {
    const {page} = action.payload;
    state[page].newTabContents = [];
    state[page].daysTab = DEFAULT_DAYS_TAB_STATE;
    state[page].completeTab = {contents: []};
  },
});
